var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "d-flex flex-nowrap justify-content-center gap-2 gap-md-3",
      },
      [
        _vm.difference.days > 0
          ? _c(
              "div",
              {
                staticClass: "d-flex align-items-center justify-content-center",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "px-1 px-md-3 py-3 text-center countdown-min-width",
                    class: `rounded ${_vm.classes}`,
                    style: this.styles,
                  },
                  [
                    _c("div", [
                      _c("span", { staticClass: "h3 h1-md fw-bold" }, [
                        _vm._v(_vm._s(_vm.difference.days)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("small", { staticClass: "text-capitalize" }, [
                        _vm._v(_vm._s(_vm._f("translate")("days"))),
                      ]),
                    ]),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "px-1 px-md-3 py-3 text-center countdown-min-width",
                class: `rounded ${_vm.classes}`,
                style: this.styles,
              },
              [
                _c("div", [
                  _c("span", { staticClass: "h3 h1-md fw-bold" }, [
                    _vm._v(_vm._s(_vm.difference.hours)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm._f("translate")("hours"))),
                  ]),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "px-1 px-md-3 py-3 text-center countdown-min-width",
                class: `rounded ${_vm.classes}`,
                style: this.styles,
              },
              [
                _c("div", [
                  _c("span", { staticClass: "h3 h1-md fw-bold" }, [
                    _vm._v(_vm._s(_vm.difference.minutes)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm._f("translate")("minutes"))),
                  ]),
                ]),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center justify-content-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "px-1 px-md-3 py-3 text-center countdown-min-width",
                class: `rounded ${_vm.classes}`,
                style: this.styles,
              },
              [
                _c("div", [
                  _c("span", { staticClass: "h3 h1-md fw-bold" }, [
                    _vm._v(_vm._s(_vm.difference.seconds)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm._f("translate")("seconds"))),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }